
export * from '../../frontend-js-dependencies-web/__liferay__/exports/moment$min$moment-with-locales.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/moment$min$moment-with-locales.js';
export default __default__;
